export default __webpack_public_path__ + "static/media/dog_group.297e07b0.jpg";